import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import WOW from 'wowjs';
import { FaAngleUp } from "react-icons/fa";
import { Toaster } from 'sonner';

// Auth Provider
import { AuthProvider } from "./contexts/auth-context";

// Active Pages - Local Food Directory
import HomeDefault from "./pages/HomeDefault";
import About from "./pages/About";
import ListingsOne from "./pages/ListingsOne";
import ListingsDetails from "./pages/ListingsDetails";
import Categories from "./pages/Categories";
import MapView from "./pages/MapView";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Contact from "./pages/Contact";
import Error from "./pages/Error";

// Phase 2 Feature Pages
import Search from "./pages/Search";
import Compare from "./pages/Compare";
import Seasonal from "./pages/Seasonal";
import Favorites from "./pages/Favorites";

// Phase 3 Auth Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";

// SEO Dynamic Pages
import SEOPage from "./pages/SEOPage";

// Phase 2 Components - Comparison Bar (global)
import { ComparisonBar } from "./components/comparison";

// Phase 3 Components - Offline Banner
import { OfflineBanner } from "./components/ui/offline-banner";

// Unused Pages - Kept for reference
// import HomeTwo from "./pages/HomeTwo";
// import HomeThree from "./pages/HomeThree";
// import ListingsTwo from "./pages/ListingsTwo";
// import ListingsThree from "./pages/ListingsThree";
// import Visited from "./pages/Visited";
// import Team from "./pages/Team";
// import TeamDetails from "./pages/TeamDetails";

import ScrollToTopRoute from './components/scroll-to-top-route/ScrollToTopRoute';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';

function App() {
  useEffect(() => {
    new WOW.WOW({
        live: false
      }).init();
    }, []
  );
  return (
    <Router>
      <AuthProvider>
        <OfflineBanner />
        <ScrollToTopRoute />
        <Routes>
            {/* Local Food Directory Routes */}
            <Route path="/" element={<HomeDefault />} />
            <Route path="/browse" element={<ListingsOne />} />
            <Route path="/category/:slug" element={<Categories />} />
            <Route path="/listing/:id" element={<ListingsDetails />} />
            <Route path="/map" element={<MapView />} />
            <Route path="/events" element={<Blog />} />
            <Route path="/events/:slug" element={<BlogDetails />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* Phase 2 Feature Routes */}
            <Route path="/search" element={<Search />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/seasonal" element={<Seasonal />} />
            <Route path="/favorites" element={<Favorites />} />

            {/* Phase 3 Auth Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Dynamic Content Pages */}
            <Route path="/produce/:slug" element={<SEOPage pageType="product" />} />
            <Route path="/guide/:slug" element={<SEOPage pageType="guide" />} />
            <Route path="/farms/:slug" element={<SEOPage pageType="location" />} />
            <Route path="/seasonal/:slug" element={<SEOPage pageType="seasonal" />} />
            <Route path="/recipe/:slug" element={<SEOPage pageType="recipe" />} />

            {/* Fallback route */}
            <Route path="/*" element={<Error />} />
        </Routes>
        {/* Global Comparison Bar - shows when items are selected */}
        <ComparisonBar />
        <Toaster position="top-right" richColors />
        <ScrollToTop className="scrollUp" smooth top="1500" component={<FaAngleUp />} />
      </AuthProvider>
    </Router>
  );
}

export default App;
